import React, { useState } from "react";
import { useAuth } from "./AuthContext";

const LoginComponent_ROJO = () => {
  const { login, cargando, error } = useAuth();
  const [usuario, setUsuario] = useState("");
  const [clave, setClave] = useState("");
  const [mostraClave, setMostraClave] = useState(false);
  const [intentosFallidos, setIntentosFallidos] = useState(0);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (intentosFallidos >= 5) {
      alert("⚠️ Cuenta bloqueada por muchos intentos. Intenta más tarde.");
      return;
    }

    if (!usuario || !clave) {
      alert("⚠️ Por favor completa usuario y clave");
      return;
    }

    const resultado = await login(usuario, clave);
    if (!resultado || !resultado.exito) {
      setIntentosFallidos(intentosFallidos + 1);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #dc2626 0%, #991b1b 100%)',
      padding: '20px'
    }}>
      <div style={{
        background: 'rgba(255, 255, 255, 0.1)',
        backdropFilter: 'blur(10px)',
        borderRadius: '24px',
        padding: '40px',
        maxWidth: '420px',
        width: '100%',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
      }}>

        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          {/* Logo de empresa */}
          <img 
            src="./logo BIGBURGUER.jpg.jpg" 
            alt="Logo BIGBURGUER" 
            style={{
              width: '80px',
              height: '80px',
              margin: '0 auto 16px',
              borderRadius: '12px',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
              objectFit: 'cover'
            }}
          />

          <h1 style={{ 
            color: 'white', 
            fontSize: '32px', 
            fontWeight: 'bold',
            marginBottom: '8px' 
          }}>
            BIGBURGUER
          </h1>
        </div>

        {error && (
          <div style={{
            background: 'rgba(239, 68, 68, 0.3)',
            border: '1px solid rgba(239, 68, 68, 0.5)',
            color: '#fecaca',
            padding: '16px',
            borderRadius: '10px',
            marginBottom: '20px',
            fontSize: '14px'
          }}>
            <strong>❌ Error: </strong>{error}
            {intentosFallidos > 0 && (
              <div style={{ marginTop: '8px', fontSize: '12px' }}>
                Intentos fallidos: {intentosFallidos}/5
              </div>
            )}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ 
              color: 'rgba(255, 255, 255, 0.9)', 
              fontSize: '14px', 
              fontWeight: '500',
              display: 'block', 
              marginBottom: '8px' 
            }}>
              👤 Usuario
            </label>
            <input
              type="text"
              value={usuario}
              onChange={(e) => setUsuario(e.target.value)}
              placeholder=""
              style={{
                background: 'rgba(255, 255, 255, 0.1)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                color: 'white',
                padding: '12px 16px',
                borderRadius: '10px',
                width: '100%',
                fontSize: '14px',
                transition: 'all 0.3s ease',
                fontFamily: 'inherit'
              }}
              onFocus={(e) => {
                e.target.style.background = 'rgba(255, 255, 255, 0.15)';
                e.target.style.borderColor = 'rgba(255, 255, 255, 0.4)';
              }}
              onBlur={(e) => {
                e.target.style.background = 'rgba(255, 255, 255, 0.1)';
                e.target.style.borderColor = 'rgba(255, 255, 255, 0.2)';
              }}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ 
              color: 'rgba(255, 255, 255, 0.9)', 
              fontSize: '14px',
              fontWeight: '500',
              display: 'block', 
              marginBottom: '8px' 
            }}>
              🔒 Clave
            </label>
            <div style={{ position: 'relative' }}>
              <input
                type={mostraClave ? "text" : "password"}
                value={clave}
                onChange={(e) => setClave(e.target.value)}
                placeholder="••••••••"
                style={{
                  background: 'rgba(255, 255, 255, 0.1)',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  color: 'white',
                  padding: '12px 16px',
                  borderRadius: '10px',
                  width: '100%',
                  fontSize: '14px',
                  transition: 'all 0.3s ease',
                  fontFamily: 'inherit'
                }}
                onFocus={(e) => {
                  e.target.style.background = 'rgba(255, 255, 255, 0.15)';
                  e.target.style.borderColor = 'rgba(255, 255, 255, 0.4)';
                }}
                onBlur={(e) => {
                  e.target.style.background = 'rgba(255, 255, 255, 0.1)';
                  e.target.style.borderColor = 'rgba(255, 255, 255, 0.2)';
                }}
              />
              <button
                type="button"
                onClick={() => setMostraClave(!mostraClave)}
                style={{
                  position: 'absolute',
                  right: '12px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  fontSize: '18px',
                  color: 'rgba(255, 255, 255, 0.6)',
                  transition: 'color 0.3s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.9)'}
                onMouseLeave={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.6)'}
              >
                {mostraClave ? '👁️' : '👁️‍🗨️'}
              </button>
            </div>
          </div>

          <button
            type="submit"
            disabled={cargando}
            style={{
              background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.1))',
              color: 'white',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              padding: '12px 24px',
              borderRadius: '10px',
              width: '100%',
              fontWeight: 'bold',
              cursor: cargando ? 'not-allowed' : 'pointer',
              fontSize: '16px',
              opacity: cargando ? 0.7 : 1,
              transition: 'all 0.3s ease',
              marginTop: '10px'
            }}
            onMouseEnter={(e) => {
              if (!cargando) {
                e.target.style.background = 'linear-gradient(135deg, rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.2))';
                e.target.style.transform = 'translateY(-2px)';
              }
            }}
            onMouseLeave={(e) => {
              e.target.style.background = 'linear-gradient(135deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.1))';
              e.target.style.transform = 'translateY(0)';
            }}
          >
            {cargando ? '⏳ Autenticando...' : '🚀 Ingresar'}
          </button>
        </form>

        <div style={{
          textAlign: 'center',
          marginTop: '24px',
          color: 'rgba(255, 255, 255, 0.5)',
          fontSize: '12px'
        }}>
          <p>Versión 1.0 - Diciembre 2025</p>
        </div>
      </div>
    </div>
  );
};

export default LoginComponent_ROJO;
